import { Outlet, useLocation } from "react-router-dom";

import { useAuthUser } from "../../hooks/useAuthUser";

const EmployeeDashboard = () => {
  const location = useLocation();
  const isRootRoute = location.pathname === "/dashboard/employee";
  const { isEmployee, details } = useAuthUser();

  if (!isEmployee) {
    return <>You need to be an Employee to access this page</>;
  }

  return (
    <>
      {isRootRoute && (
        <div>
          <h1>Welcome {details?.firstName}</h1>
        </div>
      )}

      <Outlet></Outlet>
    </>
  );
};
export default EmployeeDashboard;
